import React from 'react';
import css from './footer.module.scss';

export function Footer({children, className}: {children: React.ReactNode, className: string}) {
  return (
    <footer className={css('footer', className)}>
      {children}
    </footer>
  );
}
